import { ajax } from 'cadenza/api-client/api';
import { PARAMETER_CONDITION_HASH } from 'cadenza/api-client/api-constants';
import { ConditionApi } from 'cadenza/api-client/conditions/condition-api';
import { MIMETYPE_JSON } from 'cadenza/model/media-type';
import type { TableRowDto } from 'cadenza/ui/base-table/model/table-row-dto';

export class MapConditionApi extends ConditionApi {

  registerConditionMap () {
    return ajax<string>('/maps', {
      type: 'POST',
      data: this.conditionQueryParams
    });
  }

  unregisterConditionMap (mapId: string) {
    return ajax<void>(`/maps/${mapId}`, {
      type: 'DELETE'
    });
  }

  getConditionSelectionFromFeatureSelection (featureIds: string[]) {
    return ajax<TableRowDto[]>(`${this.path}/features?${PARAMETER_CONDITION_HASH}=${this.conditionValuesSetHash}`, {
      type: 'POST',
      data: JSON.stringify(featureIds),
      contentType: MIMETYPE_JSON
    });
  }

}
